import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import fromWalletAccountAtom from './from-wallet-account.js';
const fromBalanceAtom = atom((get, { selectors }) => {
    const asset = get(fromAssetAtom);
    const walletAccount = get(fromWalletAccountAtom).toString();
    const getSpendableBalance = get(selectors.balances.getSpendable);
    const spendableBalance = getSpendableBalance({ assetName: asset.name, walletAccount });
    return spendableBalance || asset.currency.ZERO;
});
export default fromBalanceAtom;
